var stepperTexts = {
  'sv-SE': {
    increase: 'Öka',
    decrease: 'Minska'
  },
  'nb-NO': {
    increase: 'Øke',
    decrease: 'Redusere'
  },
  'da-DK': {
    increase: 'Øge',
    decrease: 'Reducere'
  },
  'fi-FI': {
    increase: 'Lisääntyä',
    decrease: 'Vähentää'
  }
};
var texts = stepperTexts;

export { texts as default };
//# sourceMappingURL=Stepper.texts.js.map
